module.exports = __webpack_public_path__ + "img/ios.eaf2db78.png";